module.exports = __webpack_public_path__ + "static/media/pseudochorthippus_parallelus_006_Tag_APA.94984b8a.mp3";